import { Link } from 'react-router-dom';
import { useLocalizedPath } from '@/hooks/useI18n';
import { useTranslation } from '@/hooks/useTranslation';
import { Container } from '@/components/Container';
import { OptimizedImage } from '@/components/OptimizedImage';

const cards = [
  {
    id: 'thingsToDo',
    image: '/images/farol-card.jpg',
    href: '/o-que-fazer-na-ilha-do-mel',
  },
  {
    id: 'beaches',
    image: '/images/praia-encantadas.jpg',
    href: '/praias-ilha-do-mel',
  },
  {
    id: 'attractions',
    image: '/images/morro-farol-vista.jpg',
    href: '/pontos-turisticos-ilha-do-mel',
  },
  {
    id: 'restaurants',
    image: '/images/fortaleza.jpg',
    href: '/melhores-restaurantes-na-ilha-do-mel',
  },
  {
    id: 'bars',
    image: '/images/sunset-beach.jpg',
    href: '/melhores-bares-na-ilha-do-mel',
  },
  {
    id: 'experiences',
    image: '/images/sailboat.jpg',
    href: '/experiencias',
  },
];

export function OQueFazerSection() {
  const localize = useLocalizedPath();
  const { t } = useTranslation();

  return (
    <section className="py-16 sm:py-20">
      <Container>
        <div className="text-center mb-12">
          <span className="font-body text-sm text-coral font-semibold uppercase tracking-wider">
            {t('home.thingsToDo.overline')}
          </span>
          <h2 className="font-display text-4xl sm:text-5xl text-warm-dark mt-1">
            {t('home.thingsToDo.title')}
          </h2>
          <p className="font-editorial text-lg text-warm-gray mt-2 max-w-2xl mx-auto">
            {t('home.thingsToDo.subtitle')}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map(card => (
            <div
              key={card.id}
              className="group flex flex-col bg-white rounded-2xl border border-sand-200 shadow-[0_2px_8px_rgba(0,0,0,0.04)] overflow-hidden hover:shadow-[0_8px_32px_rgba(11,123,123,0.12)] hover:border-teal-light/40 transition-all hover:-translate-y-1"
            >
              <div className="relative h-44">
                <OptimizedImage
                  src={card.image}
                  alt={t(`home.thingsToDo.cards.${card.id}.title`)}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="font-display text-xl text-white leading-tight">
                    {t(`home.thingsToDo.cards.${card.id}.title`)}
                  </h3>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-5">
                <p className="font-body text-sm text-warm-gray leading-relaxed mb-4">
                  {t(`home.thingsToDo.cards.${card.id}.description`)}
                </p>
                <Link
                  to={localize(card.href)}
                  className="mt-auto inline-flex items-center gap-1 font-body text-sm font-semibold text-teal-deep hover:text-[#0a6666] transition-colors"
                >
                  {t(`home.thingsToDo.cards.${card.id}.cta`)}
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
